import type { TraceEvent, TraceEventType } from "../types/api.js";
import { apiRequest } from "./api-client.js";

function withQuery(path: string, params: Record<string, string | undefined>): string {
  const q = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== "") q.set(k, v);
  }
  const s = q.toString();
  return s ? `${path}?${s}` : path;
}

export async function fetchTraceEvents(
  token: string,
  params: {
    tenantId?: string;
    eventType?: TraceEventType;
    entityType?: string;
    entityId?: string;
    productId?: string;
    orderId?: string;
    from?: string;
    to?: string;
  } = {},
): Promise<{ events: TraceEvent[] }> {
  return apiRequest<{ events: TraceEvent[] }>(withQuery("/api/v1/traceability/events", params), {
    method: "GET",
    token,
  });
}

export async function fetchTraceEventDetail(token: string, eventId: string): Promise<{ event: TraceEvent }> {
  return apiRequest<{ event: TraceEvent }>(`/api/v1/traceability/events/${eventId}`, { method: "GET", token });
}
